import RestService from '../services/rest';

async function getUserTimeTrackingByDate(filterStartDate, filterEndDate) {
  return RestService.getAuthenticated('userTimeTrackings/monitor/list', { filterStartDate, filterEndDate });
}

async function finishUserTimeTracking(trackingId, reasonCode) {
  return RestService.putAuthenticated('userTimeTrackings/finish', { trackingId, reasonCode });
}

async function deleteUserTimeTracking(trackingId) {
  return RestService.putAuthenticated('userTimeTrackings/delete', { trackingId });
}

async function getProductionOrderTimeTracking(productionOrderId) {
  return RestService.getAuthenticated('userTimeTrackings/monitor/productionOrder', { productionOrderId });
}

export default {
  getUserTimeTrackingByDate,
  finishUserTimeTracking,
  deleteUserTimeTracking,
  getProductionOrderTimeTracking,
};
